import { render, staticRenderFns } from "./ProductEdit.vue?vue&type=template&id=3ba1403b"
import script from "./ProductEdit.vue?vue&type=script&lang=ts"
export * from "./ProductEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports